import {NgModule} from '@angular/core';
import {ParticipationComponent} from './participation.component';
import {BrowserModule} from "@angular/platform-browser";
import {FormsModule} from "@angular/forms";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import {ParticipationOverallModule} from "../participation-overall/participation-overall.module";
import {ParticipationTrendModule} from "../participation-trend/participation-trend.module";
import {ParticipationHelpModule} from "../participation-help/participation-help.module";


@NgModule({ declarations: [ParticipationComponent],
    exports: [ParticipationComponent], imports: [BrowserModule,
        FormsModule,
        ParticipationOverallModule,
        ParticipationTrendModule,
        ParticipationHelpModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class ParticipationModule {
}
